import { styled } from '@mui/material';
import { GROUP_HEADING_GAP, ICON_SIZE, GRID_COLUMNS, ITEM_HEIGHT, ITEM_GAP } from './constants';

export const GroupMenuWrapper = styled('section')`
  margin-top: 1rem;
`;

export const MenuTogglerContainer = styled('div')<{ showToggler?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${GROUP_HEADING_GAP};
  ${({ showToggler }) =>
    !showToggler &&
    `
    margin-left: 1.9rem;
    margin-bottom: 1rem;
  `}
`;

export const IconBtn = styled('button')<{ open: boolean }>`
  all: unset;
  transform: ${({ open }) => (open ? 'none' : 'rotate(-90deg)')};
  transition: transform 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const StyledMenuItem = styled('li')`
  all: unset;
  margin-bottom: 0.8rem;

  display: grid;
  grid-template-columns: 15px max-content auto;
  align-items: center;
  gap: 0.5rem;
  line-height: 2rem;

  white-space: nowrap;
  overflow: hidden;

  & div:last-of-type {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & .tooltip {
    -webkit-box-shadow:
      rgb(255 255 255 / 10%) 0px -4px 40px,
      rgb(16 37 62 / 6%) 0px 4px 24px,
      rgb(75 82 93 / 4%) 0px 24px 48px !important;
    box-shadow:
      rgb(255 255 255 / 10%) 0px -4px 40px,
      rgb(16 37 62 / 6%) 0px 4px 24px,
      rgb(75 82 93 / 4%) 0px 24px 48px !important;
    font-size: 12px !important;
    opacity: 1 !important;
  }
  & .tooltip::after,
  & .tooltip::before {
    border-color: transparent !important;
  }
`;

export const TypoWrapper = styled('span')<{ onClick: () => void }>`
  margin: 0;
  padding: 0;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const ListContainer = styled('ul')<{ nItems: number }>`
  margin: 1rem 0 0 calc(${GROUP_HEADING_GAP} + ${ICON_SIZE});
  padding: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(${GRID_COLUMNS}, 1fr);
  grid-template-rows: repeat(
    ${({ nItems }) =>
      nItems % GRID_COLUMNS === 0 ? nItems / GRID_COLUMNS : Math.ceil(nItems / GRID_COLUMNS)},
    ${ITEM_HEIGHT}
  );
  grid-auto-flow: column;
  gap: ${ITEM_GAP};
`;
